import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
import { FloatingElements } from './FloatingElements';
import { useGeoPrice } from '../hooks/useGeoPrice';
const questionVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
const yesVariants = {
  hidden: {
    opacity: 0,
    scale: 0.5
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.5,
      type: 'spring',
      stiffness: 200,
      damping: 12
    }
  }
};
export function TripleYes() {
  const {
    symbol,
    offerPrice,
    label
  } = useGeoPrice();
  return <section className="bg-dark py-24 md:py-36 px-5 relative overflow-hidden" data-id="element-290">
      <div className="absolute inset-0 bg-radial-money" aria-hidden="true" data-id="element-291" />
      <FloatingElements count={10} variant="money" data-id="element-292" />

      <div className="max-w-2xl mx-auto relative z-10" data-id="element-293">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true,
        margin: '-80px'
      }} data-id="element-294">
          <h2 className="font-display text-3xl md:text-4xl font-extrabold text-white leading-tight" data-id="element-295">
            Respóndete <span className="text-gradient-money" data-id="element-296">3 preguntas</span>
          </h2>
        </motion.div>

        {/* Question 1 */}
        <motion.div className="mb-12" variants={questionVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} data-id="element-297">
          <div className="bg-dark-card border border-dark-border rounded-2xl p-7 md:p-8 mb-4" data-id="element-298">
            <p className="font-display text-xl md:text-2xl font-bold text-white leading-snug" data-id="element-299">
              ¿Quieres que tu hijo aprenda a manejar dinero{' '}
              <span className="text-money" data-id="element-300">SIN peleas</span>,{' '}
              <span className="text-money" data-id="element-301">SIN gritos</span> y{' '}
              <span className="text-money" data-id="element-302">SIN culpa</span>?
            </p>
          </div>
          <motion.div className="flex items-center justify-center gap-3" variants={yesVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-40px'
        }} data-id="element-303">
            <CheckCircleIcon className="w-8 h-8 text-money" data-id="element-304" />
            <span className="font-display text-4xl md:text-5xl font-extrabold text-money" data-id="element-305">
              SÍ
            </span>
          </motion.div>
        </motion.div>

        {/* Question 2 */}
        <motion.div className="mb-12" variants={questionVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} data-id="element-306">
          <div className="bg-dark-card border border-dark-border rounded-2xl p-7 md:p-8 mb-4" data-id="element-307">
            <p className="font-display text-xl md:text-2xl font-bold text-white leading-snug" data-id="element-308">
              ¿Te gustaría tener un sistema{' '}
              <span className="text-money" data-id="element-309">PROBADO</span> que funcione en solo{' '}
              <span className="text-money" data-id="element-310">7 minutos por semana</span>?
            </p>
          </div>
          <motion.div className="flex items-center justify-center gap-3" variants={yesVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-40px'
        }} data-id="element-311">
            <CheckCircleIcon className="w-8 h-8 text-money" data-id="element-312" />
            <span className="font-display text-4xl md:text-5xl font-extrabold text-money" data-id="element-313">
              SÍ
            </span>
          </motion.div>
        </motion.div>

        {/* Question 3 */}
        <motion.div className="mb-16" variants={questionVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} data-id="element-314">
          <div className="bg-dark-card border border-dark-border rounded-2xl p-7 md:p-8 mb-4" data-id="element-315">
            <p className="font-display text-xl md:text-2xl font-bold text-white leading-snug" data-id="element-316">
              ¿Estás listo para instalar ese sistema en tu casa{' '}
              <span className="text-gold font-extrabold" data-id="element-317">HOY</span>?
            </p>
          </div>
          <motion.div className="flex items-center justify-center gap-3" variants={yesVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-40px'
        }} data-id="element-318">
            <CheckCircleIcon className="w-8 h-8 text-money" data-id="element-319" />
            <span className="font-display text-4xl md:text-5xl font-extrabold text-money" data-id="element-320">
              SÍ
            </span>
          </motion.div>
        </motion.div>

        {/* Transition + CTA */}
        <motion.div className="text-center" initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} viewport={{
        once: true,
        margin: '-40px'
      }} data-id="element-321">
          <p className="font-display text-2xl md:text-3xl font-extrabold text-white mb-10" data-id="element-322">
            Entonces esto es para ti.
          </p>

          <a href="https://pay.hotmart.com/R104423897O" target="_blank" rel="noopener noreferrer" className="inline-block bg-gradient-to-r from-money-dark via-money to-emerald-400 text-white font-display font-extrabold text-xl md:text-2xl px-12 py-6 rounded-2xl cta-pulse hover:scale-[1.03] active:scale-[0.98] transition-transform duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-money focus-visible:ring-offset-2 focus-visible:ring-offset-dark" data-id="element-323">
            🔓 OBTENER EL SISTEMA — {symbol}
            {offerPrice} {label}
          </a>
        </motion.div>
      </div>
    </section>;
}